import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Home from '@/views/Home'
// import Channels from '@/views/Channels'
// import Community from '@/views/Community'
import Store from '@/views/Store'
import More from '@/views/More'

// import Channel from '@/views/Channel'
import ReadContent from '@/views/Read/Content'
import ReadFeed from '@/views/Read/Feed'
import ReadProduct from '@/views/Read/Product'

import SocialLogin from '@/views/Account/SocialLogin'

import PaymentComplete from '@/views/Purchase/Complete'
import ConsultingFormComplete from '@/views/Purchase/ConsultingFormComplete'
import Terms from '@/views/Read/Terms'
import FAQ from '@/views/Read/FAQ'
import EmailForm from '@/views/EmailForm'

// 주의: 주소 직접 입력해서 들어갈 수 있도록 해야 하는 친구들은 엔트리포인트에서 바로 불러와져야 되므로 스플리팅하지 않음(SSR 아니라서...)
const EmailLogin = () => import(/* webpackChunkName: "Account" */ '@/views/Account/EmailLogin');
const EmailSignUp = () => import(/* webpackChunkName: "Account" */ '@/views/Account/EmailSignUp');
const EmailConfirm = () => import(/* webpackChunkName: "Account" */ '@/views/Account/EmailConfirm');
const ResetPassword = () => import(/* webpackChunkName: "Account" */ '@/views/Account/ResetPassword');
const ResetConfirm = () => import(/* webpackChunkName: "Account" */ '@/views/Account/ResetConfirm');

const TourHome = () => import(/* webpackChunkName: "Tour" */ '@/views/TourHome');
const TourMenu = () => import(/* webpackChunkName: "Tour" */ '@/views/TourMenu');

// const ChannelsCategory = () => import(/* webpackChunkName: "Depth" */ '@/views/ChannelsCategory');
const Topic = () => import(/* webpackChunkName: "Depth" */ '@/views/Topic');
const Products = () => import(/* webpackChunkName: "Depth" */ '@/views/Products');
const Notifications = () => import(/* webpackChunkName: "Depth" */ '@/views/Notifications');
const WriteForm = () => import(/* webpackChunkName: "Depth" */ '@/views/WriteForm');
const Comments = () => import(/* webpackChunkName: "Depth" */ '@/views/Comments');
const Reviews = () => import(/* webpackChunkName: "Depth" */ '@/views/Reviews');
const Review = () => import(/* webpackChunkName: "Depth" */ '@/views/ReviewForm');
// const ChannelProfile = () => import(/* webpackChunkName: "Depth" */ '@/views/ChannelProfile');

const Purchases = () => import(/* webpackChunkName: "Buying" */ '@/views/Purchases');
const Lecture = () => import(/* webpackChunkName: "Buying" */ '@/views/Lecture');

const SearchCommunity = () => import(/* webpackChunkName: "Search" */ '@/views/Search/Community');
const SearchProducts = () => import(/* webpackChunkName: "Search" */ '@/views/Search/Products');
// const SearchChannels = () => import(/* webpackChunkName: "Search" */ '@/views/Search/Channels');

const PurchasePackage = () => import(/* webpackChunkName: "Purchase" */ '@/views/Purchase/Package');
const PurchaseAddress = () => import(/* webpackChunkName: "Purchase" */ '@/views/Purchase/Address');
const PurchasePayment = () => import(/* webpackChunkName: "Purchase" */ '@/views/Purchase/Payment');
const InvoicePayment = () => import(/* webpackChunkName: "Purchase" */ '@/views/Purchase/InvoicePayment');

// const CommunityOrder = () => import(/* webpackChunkName: "Settings" */ '@/views/CommunityOrder');
const Settings = () => import(/* webpackChunkName: "Settings" */ '@/views/Settings');
const Bookmarks = () => import(/* webpackChunkName: "Settings" */ '@/views/Bookmarks');
const Wishes = () => import(/* webpackChunkName: "Settings" */ '@/views/Wishes');
const Profile = () => import(/* webpackChunkName: "Settings" */ '@/views/Profile');
const Coupons = () => import(/* webpackChunkName: "Settings" */ '@/views/Coupons');

function castRouteParams(route) {
  return {
    ...route.params,
    idx: Number(route.params.idx),
  };
}

const index = new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
  routes: [
    // App
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/community/search',
      name: 'SearchCommunity',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: SearchCommunity
    },
    {
      path: '/notifications',
      name: 'Notifications',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Notifications,
    },
    {
      path: '/topic/:sectionIdx',
      name: 'Topic',
      meta: {
        requiresAuth: true,
        depth: true
      },
      component: Topic,
      props: true,
    },
    {
      path: '/tour',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':idx',
          name: 'TourHome',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: TourHome,
          props: castRouteParams,
        },
        {
          path: ':idx/guide',
          name: 'TourGuide',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: TourMenu,
          props: castRouteParams,
        },
        {
          path: ':idx/programs',
          name: 'TourPrograms',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: TourMenu,
          props: castRouteParams,
        },
        {
          path: ':idx/class',
          name: 'TourClass',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: TourMenu,
          props: castRouteParams,
        }
      ]
    },
    {
      path: '/write',
      name: 'WriteForm',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: WriteForm,
      props: true,
    },
    // {
    //   path: '/community',
    //   name: 'Community',
    //   component: Community,
    // },
    // {
    //   path: '/community-order',
    //   name: 'CommunityOrder',
    //   component: CommunityOrder,
    //   meta: {
    //     requiresAuth: true,
    //     depth: true,
    //   }
    // },
    {
      path: '/store',
      name: 'Store',
      component: Store,
      // meta: {
      //   requiresAuth: true,
      // }
    },
    {
      path: '/store/early-bird',
      name: 'EarlyBird',
      component: Products,
      meta: {
        requiresAuth: true,
        depth: true,
      }
    },
    {
      path: '/store/coming-soon',
      name: 'ComingSoon',
      component: Products,
      meta: {
        requiresAuth: true,
        depth: true,
      }
    },
    {
      path: '/store/search',
      name: 'SearchProducts',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: SearchProducts,
    },
    {
      path: '/purchases',
      name: 'Purchases',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Purchases,
    },
    {
      path: '/review',
      name: 'Review',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Review,
      props: true
    },
    {
      path: '/coupons',
      name: 'Coupons',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Coupons,
      props: true
    },
    // {
    //   path: '/more',
    //   name: 'More',
    //   component: More,
    // },
    // Reader
    {
      path: '/video',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':idx',
          name: 'ReadVideo',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: ReadContent,
          props: true,
        },
        {
          path: ':idx/comment',
          name: 'ReadVideoComment',
          meta: {
            requiresAuth: true,
            depth: true,
          },
          component: Comments,
          props: true,
        },
      ]
    },
    {
      path: '/content',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':idx',
          name: 'ReadContent',
          meta: {
            // requiresAuth: true,
            // get /v5/post/:idx 도 jwt 임시 해제함
            depth: true,
          },
          component: ReadContent,
          props: true,
        },
        {
          path: ':idx/comment',
          name: 'ReadContentComment',
          meta: {
            requiresAuth: true,
            depth: true,
          },
          component: Comments,
          props: true,
        },
      ]
    },
    {
      path: '/feed/:idx',
      name: 'ReadFeed',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: ReadFeed,
      props: castRouteParams,
    },
    {
      path: '/product',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':idx',
          name: 'ReadProduct',
          meta: {
            // requiresAuth: true,
            depth: true,
          },
          component: ReadProduct,
          props: castRouteParams,
        },
        {
          path: ':idx/reviews',
          name: 'ReadProductReviews',
          meta: {
            requiresAuth: true,
            depth: true,
          },
          component: Reviews,
          props: true,
        },
        {
          path: ':idx/talks',
          name: 'ReadProductTalks',
          meta: {
            requiresAuth: true,
            depth: true,
          },
          component: Comments,
          props: true,
        },
        {
          path: ':idx/lecture/:lectureIdx',
          name: 'Lecture',
          meta: {
            requiresAuth: true,
            depth: true,
          },
          component: Lecture,
          props: true,
        }
      ]
    },
    // purchase
    {
      path: '/purchase/:idx',
      name: 'PurchasePackage',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: PurchasePackage,
      props: true,
    },
    {
      path: '/purchase/:idx/address',
      name: 'PurchaseAddress',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: PurchaseAddress,
      props: true,
    },
    {
      path: '/purchase/:idx/payment',
      name: 'PurchasePayment',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: PurchasePayment,
      props: true,
    },
    {
      path: '/purchase/:idx/invoice',
      name: 'InvoicePayment',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: InvoicePayment,
      props: true,
    },
    {
      path: '/payment/complete', // 결제 완료 후 redirection 주소
      name: 'PaymentComplete',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: PaymentComplete,
    },
    {
      path: '/consulting-form/complete',
      name: 'ConsultingFormComplete',
      meta: {
        // requiresAuth: true,
        depth: true,
      },
      component: ConsultingFormComplete,
    },
    {
      path: '/settings',
      name: 'Settings',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Settings,
    },
    {
      path: '/settings/profile',
      name: 'Profile',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Profile,
    },
    {
      path: '/wishes',
      name: 'Wishes',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Wishes,
    },
    {
      path: '/bookmarks',
      name: 'Bookmarks',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: Bookmarks,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      meta: {
        depth: true
      },
      component: Terms,
    },
    {
      path: '/faq',
      name: 'FAQ',
      meta: {
        depth: true,
      },
      component: FAQ
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      meta: {
        depth: true
      },
      component: Terms,
    },
    {
      path: '/suggestion',
      name: 'Suggestion',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: EmailForm,
    },
    {
      path: '/refund-request',
      name: 'RefundRequest',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: EmailForm,
      props: true,
    },
    {
      path: '/inquiry',
      name: 'Inquiry',
      meta: {
        requiresAuth: true,
        depth: true,
      },
      component: EmailForm,
    },
    // Account
    {
      path: '/social-login',
      name: 'SocialLogin',
      component: SocialLogin,
      meta: {
        passIfAuth: true,
        depth: true
      }
    },
    {
      path: '/email-login',
      name: 'EmailLogin',
      component: EmailLogin,
      meta: {
        passIfAuth: true,
        depth: true,
      }
    },
    {
      path: '/email-sign-up',
      name: 'EmailSignUp',
      component: EmailSignUp,
      meta: {
        passIfAuth: true,
        depth: true,
      }
    },
    {
      path: '/email-confirm',
      name: 'EmailConfirm',
      component: EmailConfirm,
      meta: {
        passIfAuth: true,
        depth: true,
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        passIfAuth: true,
        depth: true,
      }
    },
    {
      path: '/reset-confirm',
      name: 'ResetConfirm',
      component: ResetConfirm,
      meta: {
        passIfAuth: true,
        depth: true,
      }
    }
  ]
});

// 로그인 가드
index.beforeEach((to, from, next) => {
  const auth = window.localStorage.getItem('jwt');
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth || auth === 'undefined' || auth === '') {
      return next({
        name: 'SocialLogin',
        query: { redirect: to.fullPath },
      });
    } else {
      return next();
    }
  } else if (to.matched.some(record => record.meta.passIfAuth)) {
    if (auth) {
      if (!from.name) {
        return next({
          name: 'Home',
          replace: true,
        });
      } else {
        return next({
          name: from.name,
          replace: true,
        });
      }
    } else {
      return next();
    }
  } else {
    return next();
  }
});

Vue.use(Router);
Vue.use(Meta);

export default index;
